import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const BASE_URL = process.env.REACT_APP_API_URL;

const createLeadAPI = (data) => {
  return axios.post(`${BASE_URL}/hduy/create`, data);
};

const getLeadsAPI = () => {
  return axios.get(`${BASE_URL}/hduy/get`);
};

export const createLead = createAsyncThunk(
  "lead/createLead",
  async (formData, { rejectWithValue }) => {
    try {
      const response = await createLeadAPI(formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Error creating lead");
    }
  }
);

export const fetchLeads = createAsyncThunk(
  "lead/fetchLeads",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getLeadsAPI();
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Error fetching leads");
    }
  }
);

const leadSlice = createSlice({
  name: "lead",
  initialState: {
    leads: [],
    loading: false,
    error: null,
    success: false,
  },
  reducers: {
    clearStatus: (state) => {
      state.loading = false;
      state.error = null;
      state.success = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createLead.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createLead.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        if (action.payload?.data) {
          state.leads.unshift(action.payload.data);
        }
      })
      .addCase(createLead.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchLeads.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchLeads.fulfilled, (state, action) => {
        state.loading = false;
        state.leads = action.payload.data;
      })
      .addCase(fetchLeads.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearStatus } = leadSlice.actions;
export default leadSlice.reducer;
